/* __next_internal_client_entry_do_not_use__ LoginButton auto */import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useUserCreate } from "@/store/User";
import styles from "./index.module.scss";
import BaseAvatarV2 from "../BaseAvatarV2";
import { useShallow } from "zustand/react/shallow";
import classNames from "classnames";
import { popupLogin } from "../popups";
import PopupComp from "../Popup";
import { useTranslations } from "next-intl";
import { useEffect } from "react";
import { getUserInfoByInit } from "@/service/register/handle";
import { openLink } from "@/handle/route";
import { GenerateLink } from "@/util";
import { IMPORT_STATUS, useIsImport } from "@/hooks/useIsImport";
export const LoginButton = () => {
  const {
    userInfo
  } = useUserCreate(useShallow(state => ({
    userInfo: state.userState
  })));
  useEffect(() => {
    getUserInfoByInit();
  }, []);
  const t = useTranslations();
  const {
    importStatus
  } = useIsImport();
  return /*#__PURE__*/_jsxs("div", {
    className: classNames(styles.globalNavRight),
    children: [/*#__PURE__*/_jsx(PopupComp, {}), userInfo.userName ? /*#__PURE__*/_jsx("div", {
      children: /*#__PURE__*/_jsx(BaseAvatarV2, {
        size: 36,
        imageSrc: userInfo.userImage,
        name: userInfo.userName,
        hasMask: true,
        userId: userInfo.userId,
        onClick: () => {
          openLink("");
        }
      })
    }) : importStatus === IMPORT_STATUS.INIT ? "" : /*#__PURE__*/_jsxs("button", {
      className: styles.build_button,
      onClick: () => {
        if (importStatus === IMPORT_STATUS.YES) {
          window.open(GenerateLink("h5_navigation"));
        } else {
          popupLogin();
        }
      },
      children: [/*#__PURE__*/_jsx("div", {
        className: styles.fill
      }), /*#__PURE__*/_jsx("div", {
        className: styles.content,
        children: t(importStatus === IMPORT_STATUS.YES ? "GlobalPopup_nav_button" : "Login_Login_Action")
      }), /*#__PURE__*/_jsx("div", {
        className: styles.text,
        children: t(importStatus === IMPORT_STATUS.YES ? "GlobalPopup_nav_button" : "Login_Login_Action")
      })]
    })]
  });
};